'use strict';

module.exports = require('react/lib/ReactDOM');



/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/react-dom/index.js
 ** module id = 120
 ** module chunks = 0 1 2 3 10 11 12 13 14 15 16 17 19 20 21 22 23 24 25 27 28 29 30
 **/